import Create from '../views/persons/Create.vue'
import Index from '../views/persons/Index.vue'
import Update from '../views/persons/Update.vue'

export default [
    {
        path: '/persons',
        name: 'persons',
        component: Index,
        meta: { title: 'Personen' }
    },
    {
        path: '/persons/index',
        redirect: '/persons'
    },
    {
        path: '/persons/create',
        name: 'persons/create',
        component: Create,
        meta: { title: 'Person anlegen' }
    },
    {
        path: '/persons/:id',
        name: 'persons/update',
        component: Update,
        meta: { title: 'Person bearbeiten' }
    }

]
